import { isEmpty } from 'lodash';
import React from 'react';
import { Form } from '@dashboard/components/Formik';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import useUserQueries from '@dashboard/hooks/queries/useUserQueries';
import { transformApiErrorToFormik } from '@dashboard/services/form';

export default function EmailSettingsForm() {
  const { user, setUser } = useAuth();
  const { updateUser } = useUserQueries();

  return (
    <Form
      enableReinitialize
      initialValues={{
        paymentNotifications: user.paymentNotifications,
        weeklyReports: user.weeklyReports,
        marketingConsent: user.marketingConsent,
      }}
      onSubmit={async (values, actions) => {
        const { data, error } = await updateUser(values, user._id);

        if (data) {
          setUser(data);
          actions.setStatus('');
        } else {
          const { status, errors } = transformApiErrorToFormik(error);

          if (!isEmpty(errors)) {
            actions.setErrors(errors);
          } else {
            actions.setStatus(status);
          }
        }
      }}
      fields={[
        {
          name: 'paymentNotifications',
          label: 'Payment, subscription, and submission notifications',
          type: 'checkbox',
        },
        {
          name: 'weeklyReports',
          label: 'Weekly sales reports',
          type: 'checkbox',
        },
        {
          name: 'marketingConsent',
          label: 'Product updates and new features',
          type: 'checkbox',
        },
      ]}
    />
  );
}
